import { render, staticRenderFns } from "./TsSelectCustomer.vue?vue&type=template&id=80f703d0&scoped=true&"
import script from "./TsSelectCustomer.vue?vue&type=script&lang=js&"
export * from "./TsSelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TsSelectCustomer.vue?vue&type=style&index=0&id=80f703d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f703d0",
  null
  
)

export default component.exports